import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';
import {TokenCommonService} from '../token-common.service';
import {AuthService} from '../auth/auth.service';

@Injectable()
export class CodigosProductoService extends TokenCommonService  {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }


  validarArchivo(archivo: any) {
    const formData = new FormData();
    formData.append('file', archivo, archivo);
    return this.tokenPost(`${ environment.API_URL }codigos/validar`, formData);
  }

  cargarArchivo(archivo: any) {
    const formData = new FormData();
    formData.append('file', archivo, archivo);
    return this.tokenPost(`${ environment.API_URL }codigos/reemplazar`, formData);
  }

  gatAll(params?: any) {
    return this.tokenGet(`${ environment.API_URL }codigos`, params);
  }

  getNoAsignados(params?: any) {
    return this.tokenGet(`${ environment.API_URL }codigos/noAsignados`, params);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/codigos-prodicto/codigos-producto.service.ts